import React from 'react';
import { Box, Typography, Container, Grid, useTheme } from '@mui/material';
import { HelpOutline as AiIcon, Book as BookIcon } from '@mui/icons-material';

// Features data structure
const features = [
    {
        icon: <AiIcon sx={{ width: '60px', height: '60px', marginBottom: 2 }} />,
        title: 'AI-Powered Learning',
        description: 'Glassyfied uses advanced AI tools like OpenAI and Gemini to provide instant answers and explanations on any topic you need help with.',
    },
    {
        icon: <BookIcon sx={{ width: '60px', height: '60px', marginBottom: 2 }} />,
        title: 'Create & Organize Notes',
        description: 'You can easily create, organize, and save your notes within the app. Keep track of key insights, ideas, and learning materials in one place.',
    },
    {
        icon: <AiIcon sx={{ width: '60px', height: '60px', marginBottom: 2 }} />,
        title: 'Instant Image to Text',
        description: 'Upload images or screenshots of content and let Glassyfied extract the information for you. Perfect for textbook pages, diagrams, and more.',
    },
];

const About = () => {
    const theme = useTheme();

    return (
        <Box sx={{ backgroundColor: 'background.default', padding: theme.spacing(8, 2) }}>
            <Container maxWidth="lg">
                {/* Title */}
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 700,
                        textAlign: 'center',
                        marginBottom: theme.spacing(4),
                        fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                    }}
                >
                    About Glassyfied
                </Typography>

                {/* Subtitle */}
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 400,
                        textAlign: 'center',
                        marginBottom: theme.spacing(6),
                        fontSize: { xs: '1rem', sm: '1.25rem' },
                    }}
                >
                    Glassyfied is your AI-powered learning companion, designed to help students, educators, and academic professionals clarify concepts, create notes, and generate content effortlessly. We bring you the power of advanced AI tools to make learning simpler, faster, and more interactive.
                </Typography>

                {/* Features Grid */}
                <Grid container spacing={4} justifyContent="center">
                    {features.map((feature, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index} sx={{ textAlign: 'center' }}>
                            {feature.icon}
                            <Typography variant="h6" sx={{ fontWeight: 600, marginBottom: theme.spacing(1) }}>
                                {feature.title}
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 400 }}>
                                {feature.description}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default About;
